export const SIZE = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export const VARIANT = {
  filled: 'filled',
  outlined: 'outlined',
  ghost: 'ghost',
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  accent: 'accent',
}

export const ICON_PLACEMENT = {
  left: 'left',
  right: 'right',
}

export const TYPE = {
  button: 'button',
  reset: 'reset',
  submit: 'submit',
}
